import { skipToken } from '@reduxjs/toolkit/query';
import WorkspaceAPI from '../WorkspaceAPI';

function useCommanderIdsByWorkspace(workspaceId: string | undefined | null) {
  const { data, isLoading, error } = WorkspaceAPI.useGetWorkspaceUsageQuery(
    workspaceId || skipToken,
    {
      skip: !workspaceId,
    }
  );

  return {
    commanders: data?.commanders ?? [],
    isLoading,
    error,
  };
}

export default useCommanderIdsByWorkspace;
